import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import AbunTable from "components/AbunTable/AbunTable";
import { useState } from "react";
import "./integration.scss";

export interface BlogFinderTableProps{
    blogUrl: string,
    isValid: boolean,
    authorName: string,
    emailAddress: string,
    createdOn: string
}


interface BlogUrlsProps{
    blogUrls: BlogFinderTableProps[]
}
const BlogFinder = (props: BlogUrlsProps) => {
    const pageSizes = [5, 10, 15, 30, 50, 100, 500];
    const [hoveredRowId, setHoveredRowId] = useState<string | null>(null);
    const [isCopied, setIsCopied] = useState<Boolean>(false);
    const [showBlogFinder, setBlogFinder] = useState(false);

    const handleMouseEnter = (rowId: string) => {
        setHoveredRowId(rowId);
    };

    const handleMouseLeave = () => {
        setHoveredRowId(null);
    };

    const handleCopy = (email: string) => {
        navigator.clipboard.writeText(email);
        setIsCopied(true)
        setTimeout(() => {
            setIsCopied(false)
        }, 2000);
    };

   
    const columnHelper = createColumnHelper<BlogFinderTableProps>();
    const columnDefs: ColumnDef<any, any>[] = ([
        columnHelper.accessor((row: BlogFinderTableProps) => row.authorName, {
            id: 'authorName',
            header:"Author Name",
            cell: props => {
                if(props.row.original.authorName){
                    return (
                        <span>{props.row.original.authorName}</span>
                    )}},
                }),
                columnHelper.display({
                    id: 'emailAddress',
                    header: "Email Address",
                    cell: props => {
                        const rowId = props.row.id;
        
                        if (props.row.original.emailAddress) {
                            return (
                                <div
                                    style={{ position: 'relative', display: 'inline-block' }}
                                    onClick={() => handleCopy(props.row.original.emailAddress)}
                                    onMouseEnter={() => handleMouseEnter(rowId)}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    <span style={{cursor: 'pointer'}}>{props.row.original.emailAddress}</span>
                                    {hoveredRowId === rowId && (
                                        <button
                                            onClick={() => handleCopy(props.row.original.emailAddress)}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                position: 'absolute',
                                                top: '50%',
                                                left: '100%',
                                                transform: 'translate(0, -50%)',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #ccc',
                                                borderRadius: '5px',
                                                padding: '5px',
                                                cursor: 'pointer',
                                                zIndex: 10,
                                            }}
                                        >
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="#8fbffa" className="bi bi-copy" viewBox="0 0 16 16" id="Copy--Streamline-Bootstrap" height="16" width="16" style={{marginRight: '3px',}}><path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2H6a2 2 0 0 1 -2 -2zm2 -1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1 -1V2a1 1 0 0 0 -1 -1zM2 5a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1 -1v-1h1v1a2 2 0 0 1 -2 2H2a2 2 0 0 1 -2 -2V6a2 2 0 0 1 2 -2h1v1z" stroke-width="1"></path></svg>
                                        {isCopied ? 'Copied!' : 'Copy'}
                                        </button>
                                    )}
                                </div>
                            );
                        }
                        return null;
                    },
                }),
            columnHelper.display({
                id: 'createdOn',
                header: "Created On",
                cell: props => {
                    if (props.row.original.createdOn) {                         
                        const date = new Date(props.row.original.createdOn);
                        return date.toLocaleString();
                    }
                },
            }),
            columnHelper.display({
                id: 'blogUrls',
                header: "Blog Urls",
                cell: props => {
                    if (props.row.original.blogUrl) {
                        return (
                            <span
                            onClick={() => {
                                window.open(props.row.original.blogUrl, '_blank');
                            }} style={{cursor: 'pointer'}}>
                                {props.row.original.blogUrl}
                            </span>                                
                        );
                    }
                },
            }),
        ])

        


    return (
        <div className={"card w-100 mt-4"}>
                    <header
                        className="card-header is-clickable"
                        onClick={() => setBlogFinder(!showBlogFinder)}
                        >
                        <p className="card-header-title">
                            Blog Finder
                        </p>
                        <span className="card-header-icon">
                          <FontAwesomeIcon icon={showBlogFinder ? faChevronDown : faChevronRight} />
                        </span>
                    </header>
                    {showBlogFinder && (
                    <div className={"card-content"}>
				        <div className={"content"}>
                            <AbunTable tableContentName={"Blog Urls"}
                                tableData={props.blogUrls}
                                columnDefs={columnDefs}
                                pageSizes={pageSizes}
                                initialPageSize={pageSizes[1]}
                                noDataText={"No Blog found"}
                                searchboxPlaceholderText={"Search Blog..."}
                            />
                        </div>
                    </div>
                    )}
            </div>
    )
}

export default BlogFinder;